import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from '../assets/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// vendor
import { CookieService } from 'ngx-cookie-service';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha-2';
// env
import { environment } from '../environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CustomSerializer, appReducers } from './store/reducers/app.reducer';
import { RouterStateSerializer } from '@ngrx/router-store';
import { SessionIdInterceptor } from './interceptors/session-id.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
// containers
import { SharedModule } from './feature-modules/shared/shared.module';
import { FeatureFlagsEffects } from './store/effects/feature-flag.effects';
import { NudeLayoutComponent } from './containers/nude-layout/nude-layout.component';
import { SimplifiedFooterComponent } from './containers/simplified-footer/simplified-footer.component';
import { HeaderNavComponent } from './containers/header-nav/header-nav.component';
import { HeaderComponent } from './containers/header/header.component';
import { EggSpinnerOverlayComponent } from './feature-modules/shared/components/egg-spinner-overlay/egg-spinner-overlay.component';
import { ApiBtnComponent } from './feature-modules/shared/components/api-btn/api-btn.component';
import { ActivateComponent } from './containers/activate/activate.component';
import { ToastNotificationContainerComponent } from './feature-modules/shared/components/toast/toast-notification-container.component';
import { AuthLayoutComponent } from './containers/auth-layout/auth-layout.component';
import { CustomerHubLayoutComponent } from './containers/customer-hub-layout/customer-hub-layout.component';
import { FooterComponent } from './containers/footer/footer.component';
import { LoginComponent } from './containers/login/login.component';
import { OffersLayoutComponent } from './containers/offers-layout/offers-layout.component';
import { ReferAFriendLayoutComponent } from './containers/refer-a-friend-layout/refer-a-friend-layout.component';
import { VersionComponent } from './containers/version/version.component';
import { RouterEffects } from './store/effects/router.effect';
import { TrustpilotComponent } from './feature-modules/shared/components/trustpilot/trustpilot.component';

@NgModule({
  declarations: [
    AppComponent,
    AuthLayoutComponent,
    ActivateComponent,
    CustomerHubLayoutComponent,
    LoginComponent,
    VersionComponent,
    FooterComponent,
    ReferAFriendLayoutComponent,
    OffersLayoutComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    SharedModule,
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    RecaptchaFormsModule,
    RecaptchaModule,
    ReactiveFormsModule,
    AppRoutingModule,
    MaterialModule,
    StoreModule.forRoot(appReducers),
    EffectsModule.forRoot([RouterEffects, FeatureFlagsEffects]),
    StoreDevtoolsModule.instrument({
      maxAge: 50,
      logOnly: environment.production,
      connectInZone: true,
    }),
    SimplifiedFooterComponent,
    HeaderNavComponent,
    HeaderComponent,
    EggSpinnerOverlayComponent,
    NudeLayoutComponent,
    ApiBtnComponent,
    ToastNotificationContainerComponent,
    TrustpilotComponent,
  ],
  providers: [
    CookieService,
    {
      provide: RouterStateSerializer,
      useClass: CustomSerializer,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionIdInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.recaptchaSiteKey,
      },
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideEnvironmentNgxMask(),
  ],
})
export class AppModule {}
